import { useEffect, useState } from 'react'
import request from 'services/request'

import usePrevious from 'hooks/usePrevious'
interface Recommends {
  id: number
  cover: string
  verticalCover: string
  description: string
  linkUrl: string
  sortCode: number
  startTime: string
  title: string
}
interface IndexConfig {
  gameIds: Array<string>
  videoUrls: Array<string>
}
export function useRecommends(): { loading: boolean; rm: Recommends[] } {
  const [rm, setRm] = useState<Recommends[]>([])
  const [loading, setLoading] = useState(true)
  const previousRm = usePrevious(rm)
  useEffect(() => {
    if (!previousRm) {
      request
        .get('gamezone/v1/recommend')
        .then((result: any) => {
          if (result?.success) {
            setLoading(false)
            setRm(result.data)
          }
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [previousRm])
  return { loading, rm }
}

interface HomeInfo {
  events: {
    id: string
    iconUrl: string
    linkUrl: string
    type: number
    title: string
    description: string
    publishTime: string
  }[]
  happended: {
    id: string
    iconUrl: string
    linkUrl: string
    type: number
    title: string
    publishingTime: string
    relationId: string
  }[]
}
export function useHomeInfo(): { loading: boolean; info: HomeInfo | undefined } {
  const [info, setInfo] = useState<HomeInfo>()
  const [loading, setLoading] = useState(true)
  const previous = usePrevious(info)
  useEffect(() => {
    if (!previous) {
      request
        .get('gamezone/v1/index/show/info')
        .then((result: any) => {
          if (result?.success) {
            setLoading(false)
            setInfo(result.data)
          }
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [previous])
  return { loading, info }
}

export function useHomeIndexConfig() {
  const [info, setInfo] = useState<IndexConfig>({
    gameIds: [],
    videoUrls: [],
  })
  const previous = usePrevious(info)
  useEffect(() => {
    if (!previous) {
      request.get<IndexConfig>('base/v1/index/config').then(result => {
        if (result?.success) {
          const { gameIds = [], videoUrls = [] } = result.data
          setInfo({
            gameIds: gameIds || [],
            videoUrls: videoUrls || [],
          })
        }
      })
    }
  }, [previous])
  return info
}
